import axios, { CreateAxiosDefaults } from 'axios';

type TCreateApiInstanceOpts = CreateAxiosDefaults & {
  version?: string;
};

export function createAPIInstance(options: TCreateApiInstanceOpts) {
  const instance = axios.create(options);

  return instance;
}
